
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  outline: none;
}
:host ::slotted(.radio-wrapper:not(:last-child)) {
  margin-right: 32px;
}
:host ::slotted(label) {
  display: flex;
}
:host .hint-wrapper {
  display: flex;
  flex-direction: row;
  align-items: start;
}
:host .hint-wrapper .hint-icon-container {
  margin-top: 4px;
  padding-right: 4px;
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
}
:host .hint-wrapper * {
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-xxs-font-size, 12px);
  font-weight: var(--slh-base-bold-font-weight, 700);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-60, #62779F);
}
:host .hint-wrapper.hidden {
  display: none;
}
`;
